import { render, staticRenderFns } from "./catalogos.vue?vue&type=template&id=a5c6f0c4&scoped=true&"
import script from "./catalogos.vue?vue&type=script&lang=js&"
export * from "./catalogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c6f0c4",
  null
  
)

export default component.exports